import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { mapManagementServiceEnvironment } from '../map-management-service-environment';
import { RuleFields } from '../schemas/rule.schema';

/**
 * Creates one or more rules
 * @param rules The rules being created
 * @returns Data object indicating success
 */
export function postRules(this: unknown, rules: RuleFields[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(mapManagementServiceEnvironment.resolve(this).rulesUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(rules),
      })
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
      })
    )
  );
}
